import AnalyticsStore from '@store/analytics';

export const fetchPacks = async ({ dateFrom, dateTo, search, }) => {
  const response = await AnalyticsStore.fetchPacks({ dateFrom, dateTo, search, });

  return response;
};